import { Label } from '@/view/components/ui/label'
import { FileUpload } from './FileUpload'
import { FieldPath, UseFormReturn } from 'react-hook-form'
import { MaterialFormValues } from '../../hooks/useMaterialForm'
import { capitalizeFirstLetter } from '@/app/utils/capitalizeFirstLetter'
import { cn } from '@/app/utils/cn'
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@/view/components/ui/form'
import { MATERIAL_RESOLUTION_TYPE } from '../helper'
import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { ResolutionType } from '@/app/entities/Material'

interface MaterialAccordionProps extends MATERIAL_RESOLUTION_TYPE {
  isDeletingMaterial: boolean
  onDeleteMaterial: (file: File) => Promise<void>
  form: UseFormReturn<MaterialFormValues>
}
export const MaterialAccordion = ({
  height,
  icon: Icon,
  name,
  type,
  width,
  form,
  isDeletingMaterial,
  onDeleteMaterial,
}: MaterialAccordionProps) => {
  const [isOpen, setIsOpen] = useState(() => type === ResolutionType.Feed)

  return (
    <div className={cn('flex flex-col space-y-2 rounded-md border p-4')}>
      <div
        className="flex justify-between"
        onClick={() => setIsOpen((s) => !s)}
      >
        <Label
          htmlFor={type}
          className="flex items-center gap-2 text-muted-foreground"
        >
          <Icon size={24} />
          <span className="font-semibold text-black">
            {capitalizeFirstLetter(name)}
          </span>
          ({width}x{height})
        </Label>

        <ChevronDown className={cn('text-gray-600', isOpen && 'rotate-180')} />
      </div>

      {isOpen && (
        <FormField
          control={form.control}
          name={`${type}ImagesFiles` as FieldPath<MaterialFormValues>}
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <FileUpload
                  isDeletingFile={isDeletingMaterial}
                  onDelete={onDeleteMaterial}
                  {...field}
                  value={field.value as File[]}
                  type={type}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </div>
  )
}
